import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import {MatkaResultItem} from '../result.type';
import dayjs from 'dayjs';
import React from 'react';
import theme from '@/style';
import {calcResultNum} from '@/common-pages/satta/satta-service';
import {useTranslation} from 'react-i18next';
import Cards from './cards';
import {ReactComponent as MatkaOpenIcon} from '@/assets/icons/home/matka-open.svg';
import {ReactComponent as MatkaCloseIcon} from '@/assets/icons/home/matka-close.svg';

const ListItem = ({
  lotteryName,
  issueNo,
  createTime,
  backImgWeb,
  openNum,
  closeNum,
  openTime,
  closeTime,
  ...props
}: MatkaResultItem) => {
  const {t} = useTranslation();

  const panel = React.useMemo(() => {
    const openSumNum = calcResultNum(openNum);
    const closeSumNum = calcResultNum(closeNum);
    return `${
      openNum && openNum.length ? openNum : '***'
    }-${openSumNum}${closeSumNum}-${
      closeNum && closeNum.length ? closeNum : '***'
    }`;
  }, [openNum, closeNum]);

  const panelItems = React.useMemo(() => panel.split(''), [panel]);

  const list = React.useMemo(() => {
    return [
      {
        title: t('result-page.matka.ank'),
        tip: t('result-page.matka.open'),
        result: props.openAnk,
      },
      {
        title: t('result-page.matka.ank'),
        tip: t('result-page.matka.close'),
        result: props.closeAnk,
      },
      {
        title: t('result-page.matka.jodi'),
        tip: '',
        result: props.jodi,
      },
      {
        title: t('result-page.matka.sp'),
        tip: t('result-page.matka.open'),
        result: props.openSp,
      },
      {
        title: t('result-page.matka.sp'),
        tip: t('result-page.matka.open'),
        result: props.closeSp,
      },
      {
        title: t('result-page.matka.dp'),
        tip: t('result-page.matka.open'),
        result: props.openDp,
      },
      {
        title: t('result-page.matka.dp'),
        tip: t('result-page.matka.close'),
        result: props.closeDp,
      },
      {
        title: t('result-page.matka.tp'),
        tip: t('result-page.matka.open'),
        result: props.openTp,
      },
      {
        title: t('result-page.matka.tp'),
        tip: t('result-page.matka.close'),
        result: props.closeTp,
      },
      {
        title: t('result-page.matka.hsa'),
        tip: t('result-page.matka.open'),
        result: props.hsaNum,
      },
      {
        title: t('result-page.matka.hsb'),
        tip: t('result-page.matka.close'),
        result: props.hsbNum,
      },
      {
        title: t('result-page.matka.fs'),
        tip: '',
        result: props.fullSangam,
      },
    ];
  }, [props, t]);

  return (
    <View
      style={[
        theme.borderRadius.m,
        theme.background.white,
        theme.overflow.hidden,
      ]}>
      <View
        style={[
          styles.cardContent,
          backImgWeb
            ? ({
                backgroundImage: `url(${backImgWeb})`,
                backgroundPosition: 'top center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% auto',
              } as never)
            : null,
        ]}>
        <View style={[styles.headerSection]}>
          <View style={[theme.flex.row, theme.flex.between]}>
            <Text
              color={'#fff'}
              fontFamily="fontDin"
              fontWeight="800"
              style={styles.title}>
              {lotteryName}
            </Text>
            <View style={[theme.flex.alignEnd]}>
              <Text color={'#fff'} textAlign="right" style={styles.metaText}>
                NO.{issueNo}
              </Text>
              <Text
                color={'#fff'}
                textAlign="right"
                style={[styles.metaText, styles.metaDate]}>
                {dayjs(createTime).format('DD-MM-YYYY')}
              </Text>
            </View>
          </View>
          <View style={[theme.flex.row, theme.flex.center]}>
            <View
              style={[
                styles.panelWrap,
                {
                  boxShadow: '0px 8px 8px 0px rgba(0, 0, 0, 0.25) inset',
                } as never,
              ]}>
              <Text style={styles.panelLabel}>{`${t(
                'satta.title.panel',
              ).toUpperCase()}:`}</Text>
              <View style={styles.panelDigits}>
                {panelItems.map((item, index) =>
                  item === '-' ? (
                    <View
                      key={`${item}-${index}`}
                      style={styles.panelDigitPlaceholder}>
                      <Text
                        fontFamily="fontDin"
                        fontWeight="bold"
                        style={styles.panelDash}>
                        -
                      </Text>
                    </View>
                  ) : (
                    <View key={`${item}-${index}`} style={styles.panelDigitBox}>
                      <Text
                        fontFamily="fontDin"
                        fontWeight="bold"
                        style={styles.panelDigit}>
                        {item}
                      </Text>
                    </View>
                  ),
                )}
              </View>
            </View>
          </View>
          <View style={[theme.flex.row, theme.flex.between, styles.timeRow]}>
            <View style={[theme.flex.row, theme.flex.centerByCol]}>
              <MatkaOpenIcon width={12} height={12} />
              <Text style={[styles.timeLabel, styles.timeLabelText]}>
                {t('home.matka.open')}
              </Text>
              <Text style={styles.timeValue}>{openTime}</Text>
            </View>
            <View style={[theme.flex.row, theme.flex.centerByCol]}>
              <MatkaCloseIcon width={12} height={12} />
              <Text style={[styles.timeLabel, styles.timeLabelText]}>
                {t('home.matka.close')}
              </Text>
              <Text style={styles.timeValue}>{closeTime}</Text>
            </View>
          </View>
        </View>
        <View style={[theme.flex.row, theme.flex.wrap, styles.cardsWrap]}>
          {list.map((item, _i) => (
            <Cards
              key={_i}
              title={item.title}
              tip={item.tip}
              digit={item.result}
              closed={!item.result || item.result === '-'}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  cardContent: {
    padding: 16,
  },
  headerSection: {
    rowGap: 8,
  },
  title: {
    fontSize: 16,
    lineHeight: 18,
  },
  panelWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    height: 40,
    paddingHorizontal: 20,
    borderRadius: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    columnGap: 8,
  },
  panelLabel: {
    color: '#FFFFFF',
    fontSize: 12,
    lineHeight: 12,
    letterSpacing: 0,
    flexShrink: 0,
  },
  panelDigits: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 2,
  },
  panelDigitBox: {
    width: 16,
    height: 24,
    borderRadius: 2,
    backgroundColor: '#000000',
    alignItems: 'center',
    justifyContent: 'center',
  },
  panelDigitPlaceholder: {
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  panelDigit: {
    color: '#FFFFFF',
    fontSize: 20,
    lineHeight: 24,
  },
  panelDash: {
    color: '#FFFFFF',
    fontSize: 20,
    lineHeight: 24,
  },
  metaText: {
    fontWeight: '500',
    fontSize: 12,
    lineHeight: 12,
  },
  metaDate: {
    marginTop: 2,
  },
  timeRow: {
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: '#FFFFFF80',
  },
  timeLabel: {
    marginLeft: 2,
  },
  timeLabelText: {
    color: theme.fontColor.secAccent,
    fontSize: 12,
    lineHeight: 12,
  },
  timeValue: {
    color: theme.fontColor.second,
    marginLeft: 4,
    fontSize: 12,
    lineHeight: 12,
  },
  cardsWrap: {
    justifyContent: 'space-between',
    rowGap: 8,
  },
});

export default ListItem;
